module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "font-size-control"
  }, _vm._l((_vm.texts), function(text, idx) {
    return _c('span', {
      key: idx,
      tag: "component"
    }, [(text.isFirst && idx > 0) ? _c('br') : _vm._e(), _vm._v(" "), (text.isFirst && idx > 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
      class: {
        'active': _vm.isSentActived(text),
          'clickable': true,
          'first': text.isFirst
      },
      domProps: {
        "innerHTML": _vm._s(_vm.isContains(text.text))
      },
      on: {
        "click": function($event) {
          _vm.$emit('selectSentId', idx, text.text)
        }
      }
    })])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-532eb5a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/Articles.vue
// module id = 727
// module chunks = 1